export default __webpack_public_path__ + "static/media/248.003804dd.gif";